import { atom } from "recoil";
import { urlSyncEffect } from "recoil-sync";
import { object } from "@recoiljs/refine";

export const queryURL = atom({
  key: "query",
  default: {},
  effects: [urlSyncEffect({ refine: object({}), storeKey: "json-query", history: "replace" })],
});
